import {downloadTemplate, exportData, importData, pageInfo} from './../api';
import {listCarrier, listShipper} from "../../../../api";

const routeTrack = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportDataObj: null,
    downloadTemplateObj: null,
    importDataObj: null,
    carrierObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    DOWNLOAD_TEMPLATE(state, data) {
      state.downloadTemplateObj = data;
    },
    IMPORT_DATA(state, data) {
      state.importDataObj = data;
    },
    LIST_CARRIER(state, data) {
      state.carrierObj = data.obj;
    }
  },
  actions: {
    //查询
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //导出文件
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //下载模板
    async downloadTemplate({commit}, obj) {
      let resp = await downloadTemplate(obj);
      commit('DOWNLOAD_TEMPLATE', resp);
    },
    //导入数据
    async importData({commit}, obj) {
      let resp = await importData(obj);
      commit('IMPORT_DATA', resp);
    },
    //承运商
    async listCarrier({commit}, obj) {
      let resp = await listCarrier(obj);
      commit('LIST_CARRIER', resp);
    }
  }
}
export default routeTrack



// WEBPACK FOOTER //
// ./src/page/transit/routeTrack/store/routeTrack.store.js